/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('HumanResourceCtrl', ["$scope","$filter","HumanResourceData","HumanResourceView","LanguageManager",
        function($scope,$filter,HumanResourceData,HumanResourceView,LanguageManager)
{

//HumanResource functions
    $scope.dd =
    {
        view :
            {
             humanResourcesView : [],//for planning TODO RENAME
             humanResourcesActiveView :  [],//Active hr
             humanResourcesDeletedView : [],
             pTView : null
            },
        edited : {hrView:null},
        skillRoot : null,//used by hrSkillCtrl
        skills:[],//used by hrSkillCtrl
        siteView :  {},
        displaySubConf : 1,
        display : {
            startDay: 0,
            nbDays: 6
        },
        loading : true,
        initTeamView : false,
        initTrashView : false
    };

        $scope.$watch('ad.dataLoaded', function(newValue, oldValue) {
            if(newValue && !$scope.dd.initTeamView) {
                if (!$scope.ad.managerMode) {
                    $scope.goToDomain("planningPos", "dashboard");
                }
                $scope.initView();
            }
        });
        $scope.sortHrActiveViewArray = function()
        {
            $scope.dd.view.humanResourcesActiveView = $filter('orderBy')($scope.dd.view.humanResourcesActiveView, 'order');
        };
        $scope.isHrArrayOrdered = function()
        {
            var humanResources = HumanResourceData.getActiveList();

            humanResources = $filter('orderBy')(humanResources, 'order');

            var orderedValues = true;
            for (var i = 0; i < humanResources.length; i++) {
                if(humanResources[i].order == null || humanResources[i].order!=i)
                    orderedValues = false;
            }
            return orderedValues;
        };
        $scope.initView = function()
        {
            var humanResources = HumanResourceData.getActiveList();
            var hrView;

            for (var i = 0; i < humanResources.length; i++) {
                hrView = new HumanResourceView(humanResources[i], HumanResourceData.getIndexOf(humanResources[i]), $scope,humanResources[i].order);
                $scope.dd.view.humanResourcesActiveView.push(hrView);
            }

            // Sort humanResourcesActiveView by order value
            if($scope.dd.view.humanResourcesActiveView.length > 1)
                $scope.sortHrActiveViewArray();

            $scope.dd.loading = false;
            $scope.dd.initTeamView = true;
        };


}]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/hr/humanResourceCtrl.js